import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Hero() {
  const driverMockup = "https://cdn.kolayyuk.com/mockup1.png";
  const shipperMockup = "https://cdn.kolayyuk.com/mockup2.png";

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#f9fafb] via-white to-[#f1f1f1] px-6 pb-16 pt-24 sm:pt-28 md:px-12 md:pb-24 md:pt-32">
      {/* -------------------- DESKTOP -------------------- */}
      <div className="mx-auto hidden max-w-7xl flex-row items-center justify-between gap-12 md:flex">
        {/* Sol */}
        <motion.div
          className="w-1/2 text-left"
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-6xl font-extrabold leading-tight text-black">
            Türkiye’nin Dijital Yük Taşıma Ağı
          </h1>

          <p className="mt-6 max-w-md text-xl text-gray-700">
            KolayYük ile yük bulmak, teklif vermek ve kazancını artırmak artık
            çok kolay.
          </p>

          <div className="mt-10 flex gap-4">
            <Link
              to="/indir"
              className="rounded-md bg-black px-8 py-3 font-semibold text-white transition hover:opacity-90"
            >
              App Store'dan İndir
            </Link>

            <Link
              to="/indir"
              className="rounded-md bg-black px-8 py-3 font-semibold text-white transition hover:opacity-90"
            >
              Google Play'den İndir
            </Link>
          </div>
        </motion.div>

        {/* Sağ */}
        <motion.div
          className="relative flex w-1/2 justify-end"
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div className="absolute right-1/3 h-[480px] w-[480px] rounded-full bg-gradient-to-tr from-gray-300 to-white opacity-70 blur-3xl"></div>

          <motion.img
            src={driverMockup}
            alt="KolayYük Nakliyeci"
            className="relative z-10 w-[320px] translate-y-3 rotate-[-8deg]"
            initial={{ y: 60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.9 }}
          />

          <motion.img
            src={shipperMockup}
            alt="KolayYük Yük Veren"
            className="relative z-20 -ml-24 w-[320px] rotate-[8deg]"
            initial={{ y: 60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.7, duration: 0.9 }}
          />
        </motion.div>
      </div>

      {/* -------------------- MOBILE -------------------- */}
      <div className="mx-auto flex max-w-sm flex-col items-center text-center md:hidden">
        <motion.h1
          className="text-3xl font-extrabold leading-tight text-black"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Türkiye’nin Dijital Yük Taşıma Ağı
        </motion.h1>

        <motion.p
          className="mt-4 text-base text-gray-700"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          KolayYük ile yük bulmak ve kazancını artırmak artık çok kolay.
        </motion.p>

        <div className="relative mb-6 mt-10 flex w-full justify-center">
          <motion.img
            src={driverMockup}
            alt="KolayYük Nakliyeci"
            className="relative z-20 w-[160px]"
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.25, duration: 0.7 }}
          />

          <motion.img
            src={shipperMockup}
            alt="KolayYük Yük Veren"
            className="relative z-10 -ml-10 w-[160px] opacity-90"
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.7 }}
          />
        </div>

        <div className="mt-4 flex w-full flex-col gap-4">
          <Link
            to="/indir"
            className="rounded-md bg-black px-6 py-3 font-semibold text-white transition hover:opacity-90"
          >
            App Store'dan İndir
          </Link>

          <Link
            to="/indir"
            className="rounded-md bg-black px-6 py-3 font-semibold text-white transition hover:opacity-90"
          >
            Google Play'den İndir
          </Link>
        </div>
      </div>
    </section>
  );
}